module.exports = __webpack_public_path__ + "15_pvis_teaser.jpg?fb83cf2367af2db64e1bc7e337e3ba38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/15_pvis_teaser.jpg
// module id = 146
// module chunks = 0